import style from './style.css';

const Expanded = ({ children, isContextCard }) => {
  return (
    <div
      className={
        isContextCard ? style.contextExpandedContainer : style.expandedContainer
      }
      style={style}>
      {children}
    </div>
  );
};

export default Expanded;



// WEBPACK FOOTER //
// ./components/accordion/expanded.js